import React from "react";
import Table from "react-bootstrap/esm/Table";
import { BsCheck2, BsX } from "react-icons/bs";
import "./TaskResultsTable2.css";

function TaskResultsTable2(props) {
  let taskAnswers = props.taskAnswers;

  const correctAnswersTotal = taskAnswers
    .filter(({ correct }) => correct === true)
    .reduce((n, { correct }) => n + correct, 0);

  let incorrectAnswersTotal = taskAnswers.filter(
    ({ correct }) => correct === false
  ).length;

  return (
    <Table className="resultsTable">
      <thead className="task-results-table-head">
        <tr>
          <th className="results-table-head-td" style={{ textAlign: "left" }}>
            {taskAnswers.length} Items
          </th>
          <th className="results-table-head-td">Correct Answers</th>
          <th className="results-table-head-td">Incorrect Answers</th>
        </tr>
      </thead>
      <tbody>
        {taskAnswers.map((data, index) => (
          <tr key={index} className="answer-results-table-row avoid-page-break">
            <td className="task-results-table-left-col">
              {index + 1}. {data.correctAnswer}
            </td>
            {data.correct === true ? (
              <td className="results-table-td">
                <img
                  src={process.env.PUBLIC_URL + "/assets/imgs/check-circle.svg"}
                  alt="Correct"
                  style={{ width: "24px", height: "24px" }}
                />
              </td>
            ) : (
              <td className="results-table-td">
                <img
                  src={process.env.PUBLIC_URL + "/assets/imgs/x-circle.svg"}
                  alt="Correct"
                  style={{ width: "24px", height: "24px" }}
                />
              </td>
            )}
            {data.correct === false ? (
              <td className="results-table-td">{data.givenAnswer}</td>
            ) : (
              <td></td>
            )}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr style={{ borderColor: "white", backgroundColor: "#f5f5f5" }}>
          <td className="task-results-table-left-col">Total</td>
          <td className="results-table-td">{correctAnswersTotal}</td>
          <td className="results-table-td">{incorrectAnswersTotal}</td>
        </tr>
      </tfoot>
    </Table>
  );
}

export default TaskResultsTable2;
